import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, FieldArray, change } from 'redux-form';
import { Row, Col, Translate, Button } from '$common';
import CSSModules from 'react-css-modules';
import style from './task-form.scss';



let FormField = props => (
  <div styleName="form-field size-small">
    {
      props.label ?
        <label htmlFor={props.name}>{props.label}</label>
      : ''
    }
    <Field
      name={props.name}
      type={props.type || 'text'}
      component={props => {
        return(
          <input
            type={props.type}
            placeholder={props.placeholder}
            className={props.className}
            defaultValue={props.input.value}
            onBlur={props.input.onChange}
          />
        )
      }}
      styleName="field"
      placeholder={props.placeholder || ''}
    />
  </div>
);
FormField = CSSModules(FormField, style, { allowMultiple: true });

@CSSModules(style, { allowMultiple: true })
class Options extends Component {

  get question() {
    const { questions, questionIndex } = this.props;
    return questions[questionIndex]
  }

  get option() {
    const { index } = this.props;
    return this.question.question_options[index];
  }

  render() {
    const { data, updateQuestion, updateOption, index, questionIndex } = this.props;

    return !this.option._destroy ? (
      <Row>
        <Col md={this.question.question_type === 'checkbox' || this.question.question_type === 'radio' ? '10/12' : '11/12'}>
          <FormField name={`${data}.label`} />
        </Col>
        {
          this.question.question_type === 'checkbox' || this.question.question_type === 'radio' ?
            <Col md="1/12" gutter={7}>
              <Button
                block
                size="small"
                type={this.option.has_extra_payload ? 'success' : 'default'}
                onClick={() => {
                  this.option.has_extra_payload ?
                    updateOption(data, 'has_extra_payload', false)
                  : updateOption(data, 'has_extra_payload', true)
                }}
              >{Translate.get('others')}</Button>
            </Col>
          : ''
        }
        <Col md="1/12">
          <Button onClick={() => updateOption(data, '_destroy', true)} size="small" type="weak" block>
            {Translate.get('remove')}
          </Button>
        </Col>
      </Row>
    ) : null
  }
}

Options = connect(
  state => {
    return {
      questions: state.form.taskForm ? state.form.taskForm.values.questions.filter( item => item._destroy !== true ) : []
    }
  },
  {
    updateQuestion: (question, field, value) => change('taskForm', `${question}.${field}`, value),
    updateOption: (option, field, value) => change('taskForm', `${option}.${field}`, value)
  }
)(Options)

export default Options



// WEBPACK FOOTER //
// ./src/components/task-form/options.js